type SendResult = { ok: true } | { ok: false; error: string };

const TG_SAME_ORIGIN_PATH = '/tg';

/** Полный URL воркера (https://....workers.dev), без слэша в конце. Пусто = POST на тот же сайт /tg */
const TG_PROXY_URL = 'https://date-tg-proxy.kostyacherepanov1.workers.dev';

function notifyUrl(): string {
  const u = TG_PROXY_URL.trim();
  if (u) return u.replace(/\/$/, '');
  return TG_SAME_ORIGIN_PATH;
}

/**
 * Креды только на сервере (workers/tg-proxy.js, functions/tg.js, setupProxy.js, api/tg.js).
 * Сюда уходит только текст формы.
 */
export async function sendTelegramFormSummary(params: {
  activity: string;
  dateLabel: string;
}): Promise<SendResult> {
  const url = notifyUrl();

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        activity: params.activity,
        dateLabel: params.dateLabel,
      }),
    });

    const data = (await res.json().catch(() => ({}))) as {
      ok?: boolean;
      description?: string;
    };

    if (!res.ok || data.ok === false) {
      const hint =
        url === TG_SAME_ORIGIN_PATH
          ? ' Если 404 — впиши URL воркера в TG_PROXY_URL в src/telegram.ts или задеплой functions/tg.js на Pages.'
          : '';
      return {
        ok: false,
        error: (data.description || `${res.status} ${res.statusText}`) + hint,
      };
    }

    return { ok: true };
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Сеть';
    return {
      ok: false,
      error: `${message}. Локально: npm start. Прод: TG_PROXY_URL в telegram.ts или POST /tg на Pages.`,
    };
  }
}
